import qs from 'qs'
import moment from 'moment'
import firstBy from 'thenby'
import {
  checkHttpStatus,
  getApiBaseUrl,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../utils/api'
import { showModal } from '../../../actions/_modal'
import { setLastSkillAssessmentAt } from '../../../actions/myquests'
import { addActiveField } from '../../../utils/addActiveField'

// All of these functions are .bind()ed to the component in ../SkillCheck/js,
// hence the this.props references

export const fetchQuest = async function (userCompiledQuestId) {
  const { token, orgId, student, isMentor } = this.props

  let url = `${getApiBaseUrlWithOrg(
    orgId
  )}/user/framework_skills/user_compiled_quests/${userCompiledQuestId}/skills_check`

  if (isMentor) {
    url = `${getApiBaseUrlWithOrg(orgId)}/users/${
      student.id
    }/framework_skills/user_compiled_quests/${userCompiledQuestId}/skills_check`
  }

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )

    const data = await response.json()
    addActiveField(
      data.course_section,
      data.course_section.start_at,
      data.course_section.end_at
    )

    return data
  } catch (e) {
    return null
  }
}

export const fetchFrameworkSkills = async function (
  frameworkSubjectId,
  gradeLevelId
) {
  const { token } = this.props

  const params = qs.stringify(
    {
      q: {
        grade_level_id_eq: gradeLevelId
      }
    },
    { arrayFormat: 'brackets', encode: false }
  )

  const url = `${getApiBaseUrl()}/api/framework_subjects/${frameworkSubjectId}/framework_skills_framework?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )

    return await response.json()
  } catch (e) {
    return []
  }
}

export const submitSkills = async function () {
  const { dispatch, isMentor, orgId, token } = this.props
  const { student, skillsChecks, quest, date } = this.state

  const self = this

  this.setState({
    isSubmitting: true
  })

  this._logSubmit()

  const skillIds = skillsChecks.map(sc => sc.skillId)
  const alphabeticalSkills = skillsChecks.sort(
    firstBy('skillName', { ignoreCase: true })
  )

  let url = isMentor
    ? `${getApiBaseUrlWithOrg(orgId)}/users/${
        student.id
      }/framework_skills/responses`
    : `${getApiBaseUrlWithOrg(orgId)}/user/framework_skills/responses`

  let requests = skillsChecks.map(sc => {
    const body = {
      evidence_statement_set_id: sc.evidenceStatementSetId,
      user_compiled_quest_id: quest.id,
      rating: Math.round(sc.masteryRatingValue * 10) / 10,
      student_note: sc.studentNote,
      mentors_note: sc.mentorNote,
      // data is only present if mentor selects one from date picker manually
      assessed_at: date
        ? moment(
            date.format('YYYY-MM-DD') + moment().format('THH:mm:ss')
          ).toISOString(true)
        : null
    }

    if (sc.focusSkill) {
      body.course_section_activity_focus_skill_id = sc.focusSkill.id
      body.user_quest_activity_id = sc.userQuestActivityId
    }

    return fetch(url, {
      method: 'POST',
      headers: getApiHeadersFromToken(token),
      body: JSON.stringify({
        user_framework_skill_response: body
      })
    })
  })

  Promise.all(requests).then(() => {
    if (!isMentor && quest) {
      // update student's ucq in myquests state to set last_skill_assessment_at
      dispatch(setLastSkillAssessmentAt(quest.id))
    }

    const modalProps = {
      source: 'Skills Check',
      isMentor: self.props.isMentor,
      student: student,
      animate: false
    }

    if (!student.id && student.value) {
      student.id = student.value
    }

    if (!student.name && student.label) {
      student.name = student.label
    }

    modalProps.skillIds = skillIds

    if (quest) {
      modalProps.userCompiledQuestId = quest.id
      modalProps.skillIdToDisplayFirst = alphabeticalSkills[0].skillId
    }

    if (self.props.actionOnClose) {
      modalProps.actionOnClose = self.props.actionOnClose
    }

    self.props.dispatch(showModal('SKILLS_TRENDS', modalProps))
  })
}
